import React, { useState } from 'react';
import styles from './Rating.module.css';

interface RatingProps {
    value?: number;
    onChange: (rating: number) => void;
    isHoliday?: boolean;
}

const Rating: React.FC<RatingProps> = ({ value = 0, onChange, isHoliday = false }) => {
    const [hover, setHover] = useState<number | null>(null);
    const [selectedRating, setSelectedRating] = useState<number>(value);

    const ratingTexts = [
        "Ужасно 😭",
        "Плохо 😔",
        "Нормально 😐",
        "Хорошо 😊",
        "Отлично 🤩"
    ];

    const handleRatingChange = (ratingValue: number) => {
        setSelectedRating(ratingValue);
        onChange(ratingValue);

        // Добавляем небольшую анимацию подтверждения
        const stars = document.querySelectorAll(`.${styles.starWrapper}`);
        stars.forEach((star, index) => {
            if (index < ratingValue) {
                star.classList.add(styles.selected);
                setTimeout(() => star.classList.remove(styles.selected), 500);
            }
        });
    };

    const StarIcon = ({ filled, tooltip }: { filled: boolean; tooltip: string }) => (
        <div
            className={styles.starWrapper}
            data-tooltip={tooltip}
            style={{
                color: filled ? (isHoliday ? '#ff6b6b' : '#ffc107') : '#aaa',
                fontSize: '32px'
            }}
        >
            ★
        </div>
    );

    return (
        <div className={`${styles.rating} ${isHoliday ? styles.holiday : ''}`}>
            {[...Array(5)].map((_, index) => {
                const ratingValue = index + 1;
                const isFilled = ratingValue <= (hover || selectedRating);
                const tooltip = ratingTexts[index];

                return (
                    <label key={index}>
                        <input
                            type="radio"
                            name="rating"
                            value={ratingValue}
                            onClick={() => handleRatingChange(ratingValue)}
                            className={styles.radio}
                        />
                        <span
                            onMouseEnter={() => setHover(ratingValue)}
                            onMouseLeave={() => setHover(null)}
                        >
                            <StarIcon filled={isFilled} tooltip={tooltip} />
                        </span>
                    </label>
                );
            })}

            <div className={styles.ratingText}>
                {selectedRating > 0 ? ratingTexts[selectedRating - 1] : "Оцените статью"}
            </div>
        </div>
    );
};

export default Rating;